var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-modal",
    clipPath: "url(#clip0_852_5248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99421 16L13.2016 16L13.2016 10.6729L13.2016 8.67906L12.0261 8.67906L12.0261 10.6729L12.0261 14.8245L7.99421 14.8245L1.29563 14.8245L1.29563 10.6729L1.29563 3.85457L4.159 3.85457L7.3557 3.85457L7.3557 3.26682L7.3557 2.67906L3.57124 2.67906L0.120117 2.67906L0.120117 10.6729L0.120117 16L7.99421 16Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76234 0.615883L8.76234 1.18975L12.4415 1.18966C13.1816 1.1896 13.7916 1.19404 13.7971 1.1995C13.8025 1.20497 12.4118 2.6047 10.7065 4.31001L7.60589 7.41058L8.0149 7.81959L8.42391 8.2286L11.5245 5.12803C13.2298 3.42272 14.6295 2.03194 14.635 2.03742C14.6405 2.04288 14.6449 2.65289 14.6448 3.39299L14.6447 7.40548L15.2186 7.40548C15.8058 7.40548 15.7985 7.41282 15.8058 7.40548C15.8131 7.39816 15.8191 3.65557 15.8191 2.36391L15.819 0.0154534L13.4706 0.0154011C12.1789 0.0153746 8.76966 0.0213525 8.76234 0.0286753C8.755 0.0360112 8.76235 0.0287448 8.76234 0.615883Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_5248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 16) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenModal);
export default __webpack_public_path__ + "static/media/icon--open-modal.c8e5309056f30efd13f65d6cb24d3ae3.svg";
export { ForwardRef as ReactComponent };